export default "/images/31c0d1d4f230aaaeec6379e56e599b0b.avif";